/** Shared label for the custom date range option across Reports, Facts & Figures and the TLV. */
export const CUSTOM_RANGE_LABEL = 'Custom Range';
